import React, { useCallback } from "react";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import usePostRequest from "../../hooks/usePostRequest";
import Card from "react-bootstrap/Card";
import { toast } from "react-toastify";
import Skeleton from "../../components/Skeleton";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import ContractCard from "./ContractCard";
import useIdleLogout from "../../hooks/useIdleLogout";

function ContractType() {
  const user = useSelector((state) => state.auth.user);

  const userPermissions = user?.permissions?.manage_rfq || [];
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);
  const canDeleteContract = hasPermission(userPermissions, "delete");
  const canWriteContract = hasPermission(userPermissions, "write");

  const [isEditing, setIsEditing] = useState(false);

  //   const canAssignRole = canWriteRole

  // const schema = Yup.object().shape({
  //   name: Yup.string()
  //     .required("Contract Type is required")
  //     .matches(
  //       /^[a-zA-Z0-9\/\s]*$/,
  //       "Contract Type can only contain letters, numbers, spaces, and slashes (/)"
  //     ),
  //   code: Yup.string()
  //     .matches(/^[A-Za-z]$/, "Please enter a single letter")
  //     .required("Letter Code is required"),
  //   description: Yup.string().optional(),
  // });

  const schema = Yup.object().shape({
    name: Yup.string()
      .required("Contract Type is required")
      .matches(
        /^[a-zA-Z0-9\/\s\-]*$/,
        "Contract Type can only contain letters, numbers, spaces, slashes (/), and hyphens (-)"
      ),
    code: Yup.string()
      .matches(/^[A-Za-z]$/, "Please enter a single letter")
      .required("Letter Code is required"),
    description: Yup.string().optional(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    data,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { isLoading: createLoading, postData: createRole } = usePostRequest(
    API_ENDPOINTS.CREATE_CONTRACT
  );

  const onSuccess = () => {
    reset({
      name: "",
      description: "",
      code: "",
      emails: "",
    });
    setIsEditing(false);
    fetchContract({ is_listing: true });
    toast.success("Contract Type created successfully");
  };

  const onError = (error) => {
    if (error?.errors?.name?.message) {
      setError("name", {
        type: "manual",
        message: error?.errors?.name?.message,
      });
    }

    if (error?.errors?.description?.message) {
      setError("description", {
        type: "manual",
        message: error?.errors?.description?.message,
      });
    }

    toast.error(error?.message);
  };

  useIdleLogout();

  const onSubmit = (data) => {
    const handleUpdateRole = () => {
      const payload = {
        contract_type_id: data.id,
        name: data?.name,
        description: data?.description,
        letter: data?.code,
        contracting_emails: data?.emails,
      };

      createRole(payload, onSuccess, onError, API_ENDPOINTS.UPDATE_CONTRACT);
    };

    if (data?.id) {
      handleUpdateRole();
      return;
    }

    const payload = {
      name: data.name,
      letter: data.code,
      description: data.description,
      contracting_emails: data.emails,
    };
    createRole(payload, onSuccess, onError);
  };

  const handleEditContract = useCallback(
    (contract) => {
      const { id, name, description, letter, contracting_emails } = contract;

      console.log("contract", contract);
      reset({
        id,
        name,
        description,
        code: letter,
        emails: contracting_emails,
      });
      setIsEditing(true);
    },
    [reset]
  );

  useEffect(() => {
    fetchContract({ is_listing: true });
  }, []);

  return (
    <>
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">Contract Type</h2>
          </div>
        </div>
      </div>

      {canWriteContract && (
        <Card>
          <Card.Body>
            <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <Row>
                <Col md={10}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label required">
                      Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      {...register("name")}
                      isInvalid={!!errors.name}
                    />
                    <Form.Text>Name can only include letters.</Form.Text>
                    <Form.Control.Feedback type="invalid">
                      {errors.name?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group className="mb-3">
                    <Form.Label className="required">Abbreviation</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Abbreviation"
                      {...register("code")}
                      style={{ height: "40px" }}
                      isInvalid={!!errors.code}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.code?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label required">
                      Email(s)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Email"
                      {...register("emails")}
                      isInvalid={!!errors.emails}
                    />
                    <Form.Text>
                      Please enter the email as it apppears on the Quote or
                      Invoice, separate the emails with commas like -{" "}
                      <span className="fw-semibold text-primary">
                        customer@aspettoinc.com, xyz@companyname.com
                      </span>
                    </Form.Text>
                    <Form.Control.Feedback type="invalid">
                      {errors.emails?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Description"
                  {...register("description")}
                  style={{ height: "100px" }}
                  isInvalid={!!errors.description}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.description?.message}
                </Form.Control.Feedback>
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="btn btn-theme me-2"
              >
                {isEditing ? "Update Contract Type" : "Add Contract Type"}
              </Button>

              <Button
                variant="outline-secondary"
                onClick={() => {
                  reset({
                    name: "",
                    description: "",
                    code: "",
                    emails: "",
                  });
                  setIsEditing(false);
                }}
              >
                Cancel
              </Button>
            </Form>
          </Card.Body>
        </Card>
      )}

      <div className="row mt-4">
        {isLoading ? (
          <Skeleton rows={5} columns={3} />
        ) : (
          data?.data?.map((contract) => (
            <ContractCard
              key={contract?.id}
              contract={contract}
              handleEditContract={handleEditContract}
              refetchContracts={() => fetchContract({ is_listing: true })}
            />
          ))
        )}
      </div>
    </>
  );
}

export default ContractType;
